import { z } from 'zod';

export const HubBatteryUpdateSchema = z.object({
  batteryLevel: z.number(),
});

export type HubBatteryUpdate = z.infer<typeof HubBatteryUpdateSchema>;
